// extracted by css-extract-rspack-plugin
export default {"cls1":"SingularMentionCitationModal-cls1_Mct","cls2":"SingularMentionCitationModal-cls2_bAR SingularMentionCitationModal-cls1_Mct"};